// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"faq__wrapper3_Q","header":"faq__header26X","content-wrapper":"faq__content-wrapper3et"};